import { render } from "./DefaultPanelSelectedTests.vue?vue&type=template&id=3b90204e"
import script from "./DefaultPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./DefaultPanelSelectedTests.vue?vue&type=script&lang=js"

import "./DefaultPanelSelectedTests.vue?vue&type=style&index=0&id=3b90204e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b90204e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b90204e', __exports__)) {
    console.log('reload')
    api.reload('3b90204e', __exports__)
  }
  
  module.hot.accept("./DefaultPanelSelectedTests.vue?vue&type=template&id=3b90204e", () => {
    console.log('re-render')
    api.rerender('3b90204e', render)
  })

}


export default __exports__